<template>
  <div v-if="isShow.isPTShow">
    这是第二页
    <button class="btn" @click="showNext">点击</button>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  props: {
    isShow: Object
  },
  methods: {
    showNext () {
      this.$emit('nextPage', 'isKVShow')
    }
  }
}
</script>

<style lang="less" scoped>

</style>
